import { render, staticRenderFns } from "./Configs.vue?vue&type=template&id=6578fbfa&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"
import style0 from "./Configs.vue?vue&type=style&index=0&id=6578fbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6578fbfa",
  null
  
)

export default component.exports